import React from 'react';
import PropTypes from 'prop-types';

import RichTextElem from './RichText.styles';

const RichText = ({ content, blockMargin }) => {
  return (
    <div className={blockMargin ? 'u-block-margins' : 'mb-6 lg:mb-10'}>
      <RichTextElem
        className="rich-text"
        data-test-id="component-richText"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

RichText.propTypes = {
  content: PropTypes.string.isRequired,
  blockMargin: PropTypes.bool,
};

RichText.defaultProps = {
  blockMargin: true,
};

export default RichText;
